// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"1e22f027","8":"c37b8dd9","53":"d35bdbac","151":"4babb651","828":"48a6b321","886":"67eda512"}[chunkId] + ".chunk.css";
};